var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:(_vm.carbonPrefix + "--breadcrumb " + _vm.carbonPrefix + "--skeleton"),attrs:{"aria-label":_vm.ariaLabel}},[_c('cv-breadcrumb-item-skeleton'),_c('cv-breadcrumb-item-skeleton'),_c('cv-breadcrumb-item-skeleton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }